import { Ellipsis, FlagTriangleRight } from 'lucide-react';
import { memo, useState } from 'react';
import { useEventCallback } from 'usehooks-ts';

import { ReportModal } from '@/features/duos/modals/reportModal';
import { Button } from '@/shared/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/shared/components/ui/dropdown-menu';
import { cn } from '@/shared/utils/cn';

export interface ProfileOverviewCardMenuProps {
  triggerClassName?: string;
  userId: string;
}

export const ProfileOverviewCardMenu = memo(
  (props: ProfileOverviewCardMenuProps) => {
    const { triggerClassName, userId } = props;
    const [isReportModalOpen, setIsReportModalOpen] = useState(false);
    const handleReportClick = useEventCallback(() => {
      setIsReportModalOpen(true);
    });

    return (
      <>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              variant="ghost"
              size="icon"
              className={cn('size-6 p-0', triggerClassName)}
            >
              <Ellipsis className="text-cold-400 size-8" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent side="left" align="start" className="w-36 p-0">
            <DropdownMenuItem
              variant="destructive"
              onClick={handleReportClick}
              className="cursor-pointer"
            >
              <FlagTriangleRight />
              <span>Report & Block</span>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
        <ReportModal
          open={isReportModalOpen}
          onOpenChange={setIsReportModalOpen}
          userId={userId}
        />
      </>
    );
  },
);
